import { jsx as _jsx } from "react/jsx-runtime";
import { Box } from '@chakra-ui/react';
const COLOR = {
    transparent: 'transparent',
    warning: 'darkOrange',
    error: 'darkRed'
};
const DotFC = ({ variant }) => {
    return _jsx(Box, { width: '6px', height: '6px', bg: COLOR[variant], borderRadius: '50%' });
};
export const Dot = DotFC;
//# sourceMappingURL=Dot.js.map